<template>
	<section class="section login">
		<div class="columns is-centered ">
			<div class="column is-6 is-4-fullhd">
				<h4 class="title is-left">{{ $t('Change Address') }}</h4>
				<b-field :type="{ 'is-danger': validation['country_code'] }"
					:message="validation['country_code'] && $t('Country name is required')" :label="$t('Country')"
					label-for="country_code">
					<!-- <b-input required :placeholder="$t('Country')" type="text" v-model="user.country_code" :counter="10"
						id="country_code"></b-input> -->
				<b-select id="country_code" v-model="user.country_code" required :placeholder="$t('Country')" :counter="10" expanded>
					<option value="HU">Magyarország</option>
					<option value="AF">Afghanistan</option>
					<option value="AX">Åland Islands</option>
					<option value="AL">Albania</option>
					<option value="DZ">Algeria</option>
					<option value="AS">American Samoa</option>
					<option value="AD">Andorra</option>
					<option value="AO">Angola</option>
					<option value="AI">Anguilla</option>
					<option value="AQ">Antarctica</option>
					<option value="AG">Antigua and Barbuda</option>
					<option value="AR">Argentina</option>
					<option value="AM">Armenia</option>
					<option value="AW">Aruba</option>
					<option value="AU">Australia</option>
					<option value="AT">Austria</option>
					<option value="AZ">Azerbaijan</option>
					<option value="BS">Bahamas</option>
					<option value="BH">Bahrain</option>
					<option value="BD">Bangladesh</option>
					<option value="BB">Barbados</option>
					<option value="BY">Belarus</option>
					<option value="BE">Belgium</option>
					<option value="BZ">Belize</option>
					<option value="BJ">Benin</option>
					<option value="BM">Bermuda</option>
					<option value="BT">Bhutan</option>
					<option value="BO">Bolivia, Plurinational State of</option>
					<option value="BQ">Bonaire, Sint Eustatius and Saba</option>
					<option value="BA">Bosnia and Herzegovina</option>
					<option value="BW">Botswana</option>
					<option value="BV">Bouvet Island</option>
					<option value="BR">Brazil</option>
					<option value="IO">British Indian Ocean Territory</option>
					<option value="BN">Brunei Darussalam</option>
					<option value="BG">Bulgaria</option>
					<option value="BF">Burkina Faso</option>
					<option value="BI">Burundi</option>
					<option value="KH">Cambodia</option>
					<option value="CM">Cameroon</option>
					<option value="CA">Canada</option>
					<option value="CV">Cape Verde</option>
					<option value="KY">Cayman Islands</option>
					<option value="CF">Central African Republic</option>
					<option value="TD">Chad</option>
					<option value="CL">Chile</option>
					<option value="CN">China</option>
					<option value="CX">Christmas Island</option>
					<option value="CC">Cocos (Keeling) Islands</option>
					<option value="CO">Colombia</option>
					<option value="KM">Comoros</option>
					<option value="CG">Congo</option>
					<option value="CD">Congo, the Democratic Republic of the</option>
					<option value="CK">Cook Islands</option>
					<option value="CR">Costa Rica</option>
					<option value="CI">Côte d'Ivoire</option>
					<option value="HR">Croatia</option>
					<option value="CU">Cuba</option>
					<option value="CW">Curaçao</option>
					<option value="CY">Cyprus</option>
					<option value="CZ">Czech Republic</option>
					<option value="DK">Denmark</option>
					<option value="DJ">Djibouti</option>
					<option value="DM">Dominica</option>
					<option value="DO">Dominican Republic</option>
					<option value="EC">Ecuador</option>
					<option value="EG">Egypt</option>
					<option value="SV">El Salvador</option>
					<option value="GQ">Equatorial Guinea</option>
					<option value="ER">Eritrea</option>
					<option value="EE">Estonia</option>
					<option value="ET">Ethiopia</option>
					<option value="FK">Falkland Islands (Malvinas)</option>
					<option value="FO">Faroe Islands</option>
					<option value="FJ">Fiji</option>
					<option value="FI">Finland</option>
					<option value="FR">France</option>
					<option value="GF">French Guiana</option>
					<option value="PF">French Polynesia</option>
					<option value="TF">French Southern Territories</option>
					<option value="GA">Gabon</option>
					<option value="GM">Gambia</option>
					<option value="GE">Georgia</option>
					<option value="DE">Germany</option>
					<option value="GH">Ghana</option>
					<option value="GI">Gibraltar</option>
					<option value="GR">Greece</option>
					<option value="GL">Greenland</option>
					<option value="GD">Grenada</option>
					<option value="GP">Guadeloupe</option>
					<option value="GU">Guam</option>
					<option value="GT">Guatemala</option>
					<option value="GG">Guernsey</option>
					<option value="GN">Guinea</option>
					<option value="GW">Guinea-Bissau</option>
					<option value="GY">Guyana</option>
					<option value="HT">Haiti</option>
					<option value="HM">Heard Island and McDonald Islands</option>
					<option value="VA">Holy See (Vatican City State)</option>
					<option value="HN">Honduras</option>
					<option value="HK">Hong Kong</option>
					<option value="IS">Iceland</option>
					<option value="IN">India</option>
					<option value="ID">Indonesia</option>
					<option value="IR">Iran, Islamic Republic of</option>
					<option value="IQ">Iraq</option>
					<option value="IE">Ireland</option>
					<option value="IM">Isle of Man</option>
					<option value="IL">Israel</option>
					<option value="IT">Italy</option>
					<option value="JM">Jamaica</option>
					<option value="JP">Japan</option>
					<option value="JE">Jersey</option>
					<option value="JO">Jordan</option>
					<option value="KZ">Kazakhstan</option>
					<option value="KE">Kenya</option>
					<option value="KI">Kiribati</option>
					<option value="KP">Korea, Democratic People's Republic of</option>
					<option value="KR">Korea, Republic of</option>
					<option value="KW">Kuwait</option>
					<option value="KG">Kyrgyzstan</option>
					<option value="LA">Lao People's Democratic Republic</option>
					<option value="LV">Latvia</option>
					<option value="LB">Lebanon</option>
					<option value="LS">Lesotho</option>
					<option value="LR">Liberia</option>
					<option value="LY">Libya</option>
					<option value="LI">Liechtenstein</option>
					<option value="LT">Lithuania</option>
					<option value="LU">Luxembourg</option>
					<option value="MO">Macao</option>
					<option value="MK">Macedonia, the former Yugoslav Republic of</option>
					<option value="MG">Madagascar</option>
					<option value="MW">Malawi</option>
					<option value="MY">Malaysia</option>
					<option value="MV">Maldives</option>
					<option value="ML">Mali</option>
					<option value="MT">Malta</option>
					<option value="MH">Marshall Islands</option>
					<option value="MQ">Martinique</option>
					<option value="MR">Mauritania</option>
					<option value="MU">Mauritius</option>
					<option value="YT">Mayotte</option>
					<option value="MX">Mexico</option>
					<option value="FM">Micronesia, Federated States of</option>
					<option value="MD">Moldova, Republic of</option>
					<option value="MC">Monaco</option>
					<option value="MN">Mongolia</option>
					<option value="ME">Montenegro</option>
					<option value="MS">Montserrat</option>
					<option value="MA">Morocco</option>
					<option value="MZ">Mozambique</option>
					<option value="MM">Myanmar</option>
					<option value="NA">Namibia</option>
					<option value="NR">Nauru</option>
					<option value="NP">Nepal</option>
					<option value="NL">Netherlands</option>
					<option value="NC">New Caledonia</option>
					<option value="NZ">New Zealand</option>
					<option value="NI">Nicaragua</option>
					<option value="NE">Niger</option>
					<option value="NG">Nigeria</option>
					<option value="NU">Niue</option>
					<option value="NF">Norfolk Island</option>
					<option value="MP">Northern Mariana Islands</option>
					<option value="NO">Norway</option>
					<option value="OM">Oman</option>
					<option value="PK">Pakistan</option>
					<option value="PW">Palau</option>
					<option value="PS">Palestinian Territory, Occupied</option>
					<option value="PA">Panama</option>
					<option value="PG">Papua New Guinea</option>
					<option value="PY">Paraguay</option>
					<option value="PE">Peru</option>
					<option value="PH">Philippines</option>
					<option value="PN">Pitcairn</option>
					<option value="PL">Poland</option>
					<option value="PT">Portugal</option>
					<option value="PR">Puerto Rico</option>
					<option value="QA">Qatar</option>
					<option value="RE">Réunion</option>
					<option value="RO">Romania</option>
					<option value="RU">Russian Federation</option>
					<option value="RW">Rwanda</option>
					<option value="BL">Saint Barthélemy</option>
					<option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
					<option value="KN">Saint Kitts and Nevis</option>
					<option value="LC">Saint Lucia</option>
					<option value="MF">Saint Martin (French part)</option>
					<option value="PM">Saint Pierre and Miquelon</option>
					<option value="VC">Saint Vincent and the Grenadines</option>
					<option value="WS">Samoa</option>
					<option value="SM">San Marino</option>
					<option value="ST">Sao Tome and Principe</option>
					<option value="SA">Saudi Arabia</option>
					<option value="SN">Senegal</option>
					<option value="RS">Serbia</option>
					<option value="SC">Seychelles</option>
					<option value="SL">Sierra Leone</option>
					<option value="SG">Singapore</option>
					<option value="SX">Sint Maarten (Dutch part)</option>
					<option value="SK">Slovakia</option>
					<option value="SI">Slovenia</option>
					<option value="SB">Solomon Islands</option>
					<option value="SO">Somalia</option>
					<option value="ZA">South Africa</option>
					<option value="GS">South Georgia and the South Sandwich Islands</option>
					<option value="SS">South Sudan</option>
					<option value="ES">Spain</option>
					<option value="LK">Sri Lanka</option>
					<option value="SD">Sudan</option>
					<option value="SR">Suriname</option>
					<option value="SJ">Svalbard and Jan Mayen</option>
					<option value="SZ">Swaziland</option>
					<option value="SE">Sweden</option>
					<option value="CH">Switzerland</option>
					<option value="SY">Syrian Arab Republic</option>
					<option value="TW">Taiwan, Province of China</option>
					<option value="TJ">Tajikistan</option>
					<option value="TZ">Tanzania, United Republic of</option>
					<option value="TH">Thailand</option>
					<option value="TL">Timor-Leste</option>
					<option value="TG">Togo</option>
					<option value="TK">Tokelau</option>
					<option value="TO">Tonga</option>
					<option value="TT">Trinidad and Tobago</option>
					<option value="TN">Tunisia</option>
					<option value="TR">Turkey</option>
					<option value="TM">Turkmenistan</option>
					<option value="TC">Turks and Caicos Islands</option>
					<option value="TV">Tuvalu</option>
					<option value="UG">Uganda</option>
					<option value="UA">Ukraine</option>
					<option value="AE">United Arab Emirates</option>
					<option value="GB">United Kingdom</option>
					<option value="US">United States</option>
					<option value="UM">United States Minor Outlying Islands</option>
					<option value="UY">Uruguay</option>
					<option value="UZ">Uzbekistan</option>
					<option value="VU">Vanuatu</option>
					<option value="VE">Venezuela, Bolivarian Republic of</option>
					<option value="VN">Viet Nam</option>
					<option value="VG">Virgin Islands, British</option>
					<option value="VI">Virgin Islands, U.S.</option>
					<option value="WF">Wallis and Futuna</option>
					<option value="EH">Western Sahara</option>
					<option value="YE">Yemen</option>
					<option value="ZM">Zambia</option>
					<option value="ZW">Zimbabwe</option>
				</b-select>
				</b-field>
				<b-field :type="{ 'is-danger': validation['region'] }"
					:message="validation['region'] && $t('Valid region is required')" :label="$t('State/Province')"
					label-for="region">
					<b-input required :placeholder="$t('Region')" type="text" v-model="user.region" :counter="10"
						id="region"></b-input>
				</b-field>

				<b-field :type="{ 'is-danger': validation['city'] }"
					:message="validation['city'] && $t('Valid city is required')" :label="$t('City')" label-for="city">
					<b-input :placeholder="$t('City')" type="text" v-model="user.city" :counter="10" id="city"></b-input>
				</b-field>
				<b-field :type="{ 'is-danger': validation['postcode'] }"
					:message="validation['postcode'] && $t('Valid Zip/Postal Code is required')" :label="$t('Zip/Postal Code')"
					label-for="postcode">
					<b-input required :placeholder="$t('Zip/Postal Code')" type="text" v-model="user.postcode" :counter="10"
						id="postcode"></b-input>
				</b-field>
				<b-field :type="{ 'is-danger': validation['address'] }"
					:message="validation['address'] && $t('Valid street address is required')" :label="$t('Street Address')"
					label-for="address">
					<b-input required :placeholder="$t('Street Address')" type="text" v-model="user.address" :counter="10"
						id="address"></b-input>
				</b-field>

				<b-field :type="{ 'is-danger': validation['phone'] }"
					:message="validation['phone'] && $t('Valid phone number is required')" :label="$t('Phone Number')"
					label-for="phone">
					<b-input required :placeholder="$t('Phone Number')" type="text" v-model="user.phone" :counter="10"
						id="phone"></b-input>
				</b-field>

				<b-field :label="$t('VAT Number (optional)')" label-for="taxVatNumber">
					<b-input :placeholder="$t('VAT Number')" type="text" v-model="user.taxVatNumber" :counter="10"
						id="taxVatNumber"></b-input>
				</b-field>


				<b-field custom-class="is-small">
					<b-checkbox name="featured" size="is-small" v-model="isSameShippingAddress" type="is-primary"
						@change.native="sameAddressChanged">
						<span class="has-text-weight-bold">{{ $t("Use the same shipping address for invoice") }}</span>
					</b-checkbox>
				</b-field>

				<div v-if="isSameShippingAddress === false">
					<b-field :type="{ 'is-danger': validation['acc_region'] }"
						:message="validation['acc_region'] && $t('Valid region is required')" :label="$t('State/Province')"
						label-for="acc_region">
						<b-input required :placeholder="$t('Region')" type="text" v-model="user.acc_region" :counter="10"
							id="acc_region"></b-input>
					</b-field>

					<b-field :type="{ 'is-danger': validation['acc_city'] }"
						:message="validation['acc_city'] && $t('Valid city is required')" :label="$t('City')" label-for="acc_city">
						<b-input :placeholder="$t('City')" type="text" v-model="user.acc_city" :counter="10"
							id="acc_city"></b-input>
					</b-field>
					<b-field :type="{ 'is-danger': validation['acc_postcode'] }"
						:message="validation['acc_postcode'] && $t('Valid Zip/Postal Code is required')"
						:label="$t('Zip/Postal Code')" label-for="acc_postcode">
						<b-input required :placeholder="$t('Zip/Postal Code')" type="text" v-model="user.acc_postcode" :counter="10"
							id="acc_postcode"></b-input>
					</b-field>
					<b-field :type="{ 'is-danger': validation['acc_address'] }"
						:message="validation['acc_address'] && $t('Valid street address is required')" :label="$t('Street Address')"
						label-for="acc_address">
						<b-input required :placeholder="$t('Street Address')" type="text" v-model="user.acc_address" :counter="10"
							id="acc_address"></b-input>
					</b-field>
				</div>

				<b-button style="margin-top:20px" type="is-primary" @click="save">{{ $t('Save') }}</b-button>

			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: 'AddressChange',
	components: {},
	metaInfo() {
		return {
			title: this.$t("Register"),
			meta: [
				{ name: 'robots', content: 'noindex' },
			]
		}
	},
	data() {
		return {
			isSameShippingAddress: true,
			user: {},
			validation: {},
		}
	},
	methods: {
		sameAddressChanged() {
			if (this.isSameShippingAddress) {
				this.user.acc_region = this.user.region;
				this.user.acc_postcode = this.user.postcode;
				this.user.acc_city = this.user.city;
				this.user.acc_address = this.user.address;
			} else {
				this.user.acc_region = '';
				this.user.acc_postcode = '';
				this.user.acc_city = '';
				this.user.acc_address = '';
			}
		},
		save() {
			this.validation = {};
			//register form validation

			if (!this.user.region || this.user.region === '') {
				this.validation["region"] = "Error";
			}

			if (!this.user.country_code || this.user.country_code === '') {
				this.validation["country_code"] = "Error";
			}

			if (!this.user.postcode || this.user.postcode === '') {
				this.validation["postcode"] = "Error";
			}

			if (!this.user.city || this.user.city === '') {
				this.validation["city"] = "Error";
			}

			if (!this.user.address || this.user.address === '') {
				this.validation["address"] = "Error";
			}

			if (!this.user.phone || this.user.phone === '') {
				this.validation["phone"] = "Error";
			}
			if (!this.isSameShippingAddress) {
				if (!this.user.acc_postcode || this.user.acc_postcode === '') {
					this.validation["acc_postcode"] = "Error";
				}

				if (!this.user.acc_city || this.user.acc_city === '') {
					this.validation["acc_city"] = "Error";
				}

				if (!this.user.acc_address || this.user.acc_address === '') {
					this.validation["acc_address"] = "Error";
				}

				if (!this.user.acc_region || this.user.acc_region === '') {
					this.validation["acc_region"] = "Error";
				}
			}

			if (Object.keys(this.validation).length !== 0) {
				return;
			}

			if (this.isSameShippingAddress) {
				this.user.acc_region = this.user.region;
				this.user.acc_postcode = this.user.postcode;
				this.user.acc_city = this.user.city;
				this.user.acc_address = this.user.address;
			}

			var _this = this
			this.$http
				.put('/users', this.user)
				.then(() => {
					_this.$buefy.snackbar.open({
						message: _this.$t('Profile saved'),
						position: 'is-top',
					})
					console.log('ROUTE', _this.$route)
					_this.$router.go();
				})
				.catch((error) => {
					console.log(JSON.stringify(error));
					_this.$buefy.snackbar.open({
						message: _this.$t('Error'),
						type: 'is-danger',
						position: 'is-top',
						duration: 5000,
					})
				})
		},
		getUser() {
			var _this = this
			setTimeout(function () {
				_this.$http.get('/users').then((response) => {
					console.log('Profile', response.data)
					_this.user = response.data.user
					_this.preferences = response.data.user.UserPreference
					console.log('___________ preferences:', _this.preferences)
					if (!_this.preferences.name) {
						_this.preferences.name = _this.user.bidder_name
					}
					if (!_this.preferences.currency) {
						_this.preferences.currency = 'HUF'
					}
					if (!_this.preferences.language) {
						_this.preferences.language = 'HU'
					}
					_this.preferences.bidder_name = _this.preferences.name
					_this.loading = false
				})
			}, 100)
		},
	},
	mounted() {
		this.getUser()
	},
}
</script>
